module.exports = __webpack_public_path__ + "img/swiper_04.d97668e2.jpg";